import React, { Component } from 'react'
import { connect } from 'react-redux'
import ReactModal from 'react-modal'
import classnames from 'classnames'

import LabeledInput from './UI/LabeledInput'
import LabeledButton from './UI/LabeledButton'
import LabeledSlider from './UI/LabeledSlider'

import tooltips from '../constants/tooltips.json'

import {
  openDeviceSync,
  fetchFirmware,
  setMIDIChannel,
  setPressureCC,
  setTiltCC,
  setBendRangePad,
  setBendRangeTilt,
  setVelocitySensitivity,
  setPressureSensitivity,
  setTiltSensitivity,
  sendPreset,
  toggleMPE,
  setMPEMemberChannels
} from '../actions'
import Preferences from './Preferences'

class EditorBody extends Component {
  state = {
    deviceSyncModalPage: 1
  }

  static skipFirmwareUpdate = false;
  shouldComponentUpdate(prevProps, nextState) {
    // if currentPreset is different
    const changedPreset = !Object.keys(prevProps.currentPreset).every((prop) => {
      return this.props.currentPreset[prop] === prevProps.currentPreset[prop]
    })

    const deviceSyncModalPageChanged = this.state.deviceSyncModalPage !== nextState.deviceSyncModalPage

    if ((this.props.deviceSyncOpen !== prevProps.deviceSyncOpen) || deviceSyncModalPageChanged || changedPreset) {
      return true
    } else {
      return false
    }
  }

  afterOpenModal = () => {
    // console.log('device sync modal open')
  }

  handleCloseModal = () => {
    this.props.onToggleDeviceSync(false)
    console.log('device sync modal close')
  }

  render() {
    const {
      //isBeta,
      deviceSyncOpen,
      onSetMIDIChannel,
      onSetPressureCC,
      onSetTiltCC,
      onSetBendRangePad,
      onSetBendRangeTilt,
      onSetVelocitySensitivity,
      onSetPressureSensitivity,
      onSetTiltSensitivity,
      onToggleDeviceSync,
      onFetchFirmware,
      availableFirmware,
      onSendPreset,
      onToggleMPE,
      onSetMPEMemberChannels,
      showTooltips
    } = this.props

    const {
      mpe_active,
      mpe_member_channels,
      midi_channel,
      pressure_cc,
      tilt_cc,
      bend_range_pad,
      bend_range_tilt,
      velocity_sensitivity,
      pressure_sensitivity,
      tilt_sensitivity
    } = this.props.currentPreset

    if (!Preferences.fwMatches() && !this.skipFirmwareUpdate)
    {
      this.setState({ deviceSyncModalPage: 3 }) // 3 is fw update modal
    }
    return (
      <div className="editor-body">
        <ReactModal
          isOpen={deviceSyncOpen}
          className="react-modal"
          contentLabel="DeviceSync"
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.handleCloseModal}
          shouldCloseOnOverlayClick={false}
          closeTimeoutMS={0}
          overlayClassName="react-modal-overlay"
          parentSelector={() => document.querySelector('#root .editor')}
        >
          <div
            className="device-sync">
            <div className={classnames("fwMisMatch", { 'hidden': this.state.deviceSyncModalPage !== 3})}>
              <p>K-Board firmware is out of date.</p>
              <div className="button-container">
                <button
                  className="button"
                  onClick={() => {
                    onFetchFirmware(availableFirmware.url);
                    this.setState({ deviceSyncModalPage: 1 }) // sync modal
                  }}
                >Update</button>
                <button
                  className="button"
                  onClick={() => {
                    this.skipFirmwareUpdate = true;
                    //this.setState({ skipFirmwareUpdate: true }) // 3 is fw update modal
                    //window.location = 'https://files.keithmcmillen.com/products/k-board/editor/CHANGELOG.md';
                    this.setState({ deviceSyncModalPage: 1 }) // sync modal
                  }}
                >Cancel</button>
              </div>
            </div>
            <div className={classnames("part-one", { 'hidden': this.state.deviceSyncModalPage !== 1 })}>
              <p>Send current editor settings to K-Board?</p>
              <div className="button-container">
                <button
                  className="button"
                  onClick={() => {
                    onSendPreset()
                    onToggleDeviceSync(false)
                    this.setState({ deviceSyncModalPage: 1 })
                  }}
                >Yes</button>
                <button
                  className="button"
                  onClick={() => {
                    this.setState({ deviceSyncModalPage: 2 })
                  }}
                >No</button>
              </div>

            </div>
            <div className={classnames("part-two", { 'hidden': this.state.deviceSyncModalPage !== 2 })}>
              <p>All editor settings will be sent to the K-Board when any parameter is updated.</p>
              <div className="button-container single">
                <button
                  className="button"
                  onClick={() => {
                    onToggleDeviceSync(false)
                    this.setState({ deviceSyncModalPage: 1 })
                  }}
                >OK</button>
              </div>
            </div>
          </div>
        </ReactModal>
        <LabeledButton
          label="MPE"
          tip={tooltips['mpe_active']}
          multiline="true"
          place="bottom"
          data-tip-disable={!showTooltips}
          toggleValues={[{'label':'Off', 'value': false}, {'label':'On', 'value': true}]}
          value={mpe_active ? true : false}
          onClick={onToggleMPE}
        />
        {
          mpe_active ? <LabeledInput
            label="MPE Member Channels"
            tip={tooltips['mpe_member_channels']}
            multiline="true"
            place="bottom"
            min={1} max={15}
            value={mpe_member_channels}
            onChange={onSetMPEMemberChannels}
          /> : <LabeledInput
            label={"MIDI Channel"}
            tip={tooltips['midi_channel']}
            multiline="true"
            place="bottom"

            min={1} max={16}
            value={midi_channel + 1}
            onChange={onSetMIDIChannel}
          />
        }
        <LabeledInput
          tip={tooltips['pressure_cc']}
          multiline="true"
          place="bottom"
          label={mpe_active ? "Pressure CC" : "Pressure CC"}
          min={-1} max={127}
          value={mpe_active ? -1 : pressure_cc}
          disabled={mpe_active}
          onChange={onSetPressureCC}
        />
        { mpe_active ? <LabeledButton
          label="Tilt CC"
          tip={tooltips['tilt_cc']}
          multiline="true"
          place="bottom"
          toggleValues={[{'label':'Bend', 'value': -1}, {'label':'74', 'value': 74}]}
          value={tilt_cc}
          onClick={(v) => {
            // toggle between toggleValues (set internally)
            onSetTiltCC(v)
          }}
        /> : <LabeledInput
        tip={tooltips['tilt_cc']}
        multiline="true"
        place="bottom"

        label="Tilt CC"
        min={-1} max={127}
        value={tilt_cc}
        onChange={onSetTiltCC}
      />
        }
        <LabeledInput
          tip={tooltips['bend_range_pad']}
          multiline="true"
          place="bottom"

          label="Bend Range (Pad)"
          min={1} max={12}
          value={bend_range_pad}
          onChange={onSetBendRangePad}
        />
        <LabeledInput
          tip={tooltips['bend_range_tilt']}
          multiline="true"
          place="bottom"

          label="Bend Range (Tilt)"
          min={1} max={12}
          value={bend_range_tilt}
          onChange={onSetBendRangeTilt}
        />

        <LabeledSlider
          data-tip={tooltips['velocity_sensitivity']}
          data-multiline="true"
          data-place="top"
          data-tip-disable={!showTooltips}

          label="Velocity Sensitivity"
          value={velocity_sensitivity}
          domain={[60, 254]}
          onChange={onSetVelocitySensitivity}
        />
        <LabeledSlider
          data-tip={tooltips['pressure_sensitivity']}
          data-multiline="true"
          data-place="top"
          data-tip-disable={!showTooltips}

          label="Pressure Sensitivity"
          value={pressure_sensitivity}
          domain={[60, 254]}
          onChange={onSetPressureSensitivity}
        />
        <LabeledSlider
          data-tip={tooltips['tilt_sensitivity']}
          data-multiline="true"
          data-place="top"
          data-tip-disable={!showTooltips}

          label="Tilt Sensitivity"
          value={tilt_sensitivity}
          domain={[0, 70]}
          onChange={onSetTiltSensitivity}
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    availableFirmware: state.device.availableFirmware,
    isBeta: state.editor.beta,
    deviceSyncOpen: state.editor.deviceSyncOpen,
    currentPreset: state.currentPreset,
    showTooltips: state.editorPreferences.showTooltips
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onToggleDeviceSync: (action) => {
      dispatch(openDeviceSync(action))
    },
    onFetchFirmware: (url) => {
      dispatch(fetchFirmware(url))
    },
    onSendPreset: () => {
      dispatch(sendPreset())
    },
    onToggleMPE: () => {
      dispatch(toggleMPE())
    },
    onSetMPEMemberChannels: (channels) => {
      dispatch(setMPEMemberChannels(channels))
    },
    onSetMIDIChannel: (channel) => {
      dispatch(setMIDIChannel(channel - 1))
    },
    onSetPressureCC: (cc) => {
      dispatch(setPressureCC(cc))
    },
    onSetTiltCC: (cc) => {
      dispatch(setTiltCC(cc))
    },
    onSetBendRangePad: (range) => {
      dispatch(setBendRangePad(range))
    },
    onSetBendRangeTilt: (range) => {
      dispatch(setBendRangeTilt(range))
    },
    onSetVelocitySensitivity: (sensitivity) => {
      dispatch(setVelocitySensitivity(~~sensitivity[0]))
    },
    onSetPressureSensitivity: (sensitivity) => {
      dispatch(setPressureSensitivity(~~sensitivity[0]))
    },
    onSetTiltSensitivity: (sensitivity) => {
      dispatch(setTiltSensitivity(~~sensitivity[0]))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditorBody)
